module.exports = __webpack_public_path__ + "img/dribble-logo.8eaa8baf.svg";